import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { Provider } from "react-redux";
import { index } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(index);

root.render(
  <React.StrictMode>
      <Provider store={index}>
          <BrowserRouter>
              <PersistGate persistor={persistor}>
                  <App />
              </PersistGate>
          </BrowserRouter>
      </Provider>
  </React.StrictMode>
);
